(() => {
  const normalize = (value) =>
    String(value || "")
      .toLocaleLowerCase("pl")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, " ")
      .trim();

  const initialize = (root) => {
    if (!root || root.dataset.faqInitialized === "true") return;

    root.dataset.faqInitialized = "true";
    root.classList.add("is-enhanced");

    const search = root.querySelector("[data-faq-search]");
    const clear = root.querySelector("[data-faq-clear]");
    const status = root.querySelector("[data-faq-status]");
    const empty = root.querySelector("[data-faq-empty]");
    const content = root.querySelector(".pf-faq__content");
    const expand = root.querySelector("[data-faq-expand]");
    const collapse = root.querySelector("[data-faq-collapse]");
    const items = [...root.querySelectorAll("[data-faq-item]")];
    const categories = [...root.querySelectorAll("[data-faq-category]")];
    const navLinks = [...root.querySelectorAll("[data-faq-nav]")];
    const total = items.length;

    items.forEach((item) => {
      item.dataset.faqSearchText = normalize(item.textContent);
    });

    const visibleItems = () => items.filter((item) => !item.hidden);

    const updateSearch = () => {
      const query = normalize(search?.value);
      let matches = 0;

      root.classList.toggle("is-searching", Boolean(query));

      items.forEach((item) => {
        const matched =
          !query || item.dataset.faqSearchText.includes(query);

        item.hidden = !matched;

        if (matched) {
          matches += 1;
        } else {
          item.open = false;
        }
      });

      categories.forEach((category) => {
        const hasVisibleItem = [...category.querySelectorAll("[data-faq-item]")]
          .some((item) => !item.hidden);

        category.hidden = !hasVisibleItem;
      });

      navLinks.forEach((link) => {
        const key = link.dataset.faqNav;
        const category = root.querySelector(
          `[data-faq-category="${CSS.escape(key)}"]`
        );

        link.hidden = Boolean(category?.hidden);
      });

      if (status) {
        status.textContent = query
          ? `Znaleziono ${matches} ${matches === 1 ? "odpowiedź" : "odpowiedzi"}`
          : `${total} odpowiedzi w ${categories.length} kategoriach`;
      }

      if (empty) {
        empty.hidden = matches !== 0;
      }

      if (content) {
        content.hidden = matches === 0;
      }
    };

    let searchTimer;

    search?.addEventListener("input", () => {
      window.clearTimeout(searchTimer);
      searchTimer = window.setTimeout(updateSearch, 90);
    });

    search?.addEventListener("search", updateSearch);

    clear?.addEventListener("click", () => {
      if (!search) return;

      search.value = "";
      updateSearch();
      search.focus();
    });

    expand?.addEventListener("click", () => {
      visibleItems().forEach((item) => {
        item.open = true;
      });
    });

    collapse?.addEventListener("click", () => {
      items.forEach((item) => {
        item.open = false;
      });
    });

    const setActiveNav = (key) => {
      navLinks.forEach((link) => {
        if (link.dataset.faqNav === key) {
          link.setAttribute("aria-current", "true");
        } else {
          link.removeAttribute("aria-current");
        }
      });
    };

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (normalize(search?.value)) return;

          const visibleEntry = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visibleEntry) {
            setActiveNav(visibleEntry.target.dataset.faqCategory);
          }
        },
        {
          rootMargin: "-18% 0px -65% 0px",
          threshold: [0.05, 0.2, 0.5],
        }
      );

      categories.forEach((category) => observer.observe(category));
    }

    navLinks.forEach((link) => {
      link.addEventListener("click", () => {
        setActiveNav(link.dataset.faqNav);
      });
    });

    updateSearch();
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll("[data-faq-root]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAll(event.target);
  });
})();
